import { copyObjectWithoutKeys } from '../../../../../../../utils'

import { type CybusDetailedService, type CybusService, StatusType } from '../../../../../../../domain'

import type { BackendDefinition } from '../../../../../../Connectware'
import { mapBaseService } from '.'

/**
 * Return 0 if service is disabled (no resources available), otherwise return count
 */
const getAvailableResourceCount = (currentState: StatusType, count: number): number => (currentState === StatusType.DISABLED ? 0 : count)

export const mapDetailedService = (
    {
        serviceId,
        name,
        version,
        currentState,
        description,
        icon,
        provider,
        parameters,

        mappingCount,
        volumeCount,
        serverCount,
        nodeCount,
        containerCount,
        connectionCount,
        endpointCount,
        roleCount,
        userCount,
        ingressRouteCount,
    }: BackendDefinition<'service-manager', 'ServiceDetails'>,
    links: BackendDefinition<'service-manager', 'LinkedService'>['links'],
    { dependent, dependsOn }: BackendDefinition<'service-manager', 'ServiceDependencies'>,
    resourceDeviationsCount: number
): CybusDetailedService => {
    const domainService: CybusService = {
        ...mapBaseService({ serviceId, name, version, currentState }, resourceDeviationsCount > 0),
        links: [...links],
    }

    return {
        ...domainService,
        version: domainService.version || null,
        description: description.trim(),
        icon: icon || null,
        provider: provider || null,
        configuredResources: {
            connections: connectionCount,
            containers: containerCount,
            endpoints: endpointCount,
            mappings: mappingCount,
            roles: roleCount,
            routes: ingressRouteCount,
            servers: serverCount,
            nodes: nodeCount,
            users: userCount,
            volumes: volumeCount,
        },
        availableResources: {
            mappings: getAvailableResourceCount(domainService.status, mappingCount),
            volumes: getAvailableResourceCount(domainService.status, volumeCount),
            servers: getAvailableResourceCount(domainService.status, serverCount),
            nodes: getAvailableResourceCount(domainService.status, nodeCount),
            containers: getAvailableResourceCount(domainService.status, containerCount),
            connections: getAvailableResourceCount(domainService.status, connectionCount),
            endpoints: getAvailableResourceCount(domainService.status, endpointCount),
        },
        /** Id should not be passed on the parameters */
        parameters: copyObjectWithoutKeys(parameters, 'id'),
        resourceDeviationsCount,
        dependencies: { dependent: [...dependent], dependsOn: [...dependsOn] },
    }
}
